import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { InterventionLadderPeriod } from '../../../api-service/clients';
import { intensityGradient, stepBackgrounds } from './intervention-ladder-colors';

const selectedColor = stepBackgrounds[stepBackgrounds.length - 1];

export interface InterventionLadderCaptionProps {
  period: InterventionLadderPeriod;
  currentYear: number;
  onSelectPeriod: (period: InterventionLadderPeriod) => void;
}

export function formatPeriod(period: InterventionLadderPeriod, currentYear: number) {
  switch (period) {
    case InterventionLadderPeriod.ThisYear:
      return `${currentYear}`;
    case InterventionLadderPeriod.LastYear:
      return `${currentYear - 1}`;
    case InterventionLadderPeriod.YearBefore:
      return `${currentYear - 2}`;
    default:
      return 'Sidste 12 mdr.';
  }
}

export function InterventionLadderCaption({ period, currentYear, onSelectPeriod }: InterventionLadderCaptionProps) {
  const periods = [InterventionLadderPeriod.Last12Months, InterventionLadderPeriod.ThisYear, InterventionLadderPeriod.LastYear, InterventionLadderPeriod.YearBefore].map(
    option => ({ period: option, label: formatPeriod(option, currentYear) })
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 2 }}>
      <Typography sx={{ fontSize: '0.8125rem', fontStyle: 'italic', color: 'text.secondary' }}>
        Målet er at flytte borgere{' '}
        <Box component="strong" sx={{ fontStyle: 'normal', fontWeight: 600, color: 'text.primary' }}>
          ned ad trappen
        </Box>{' '}
        mod størst mulig selvstændighed.
      </Typography>
      <Box sx={{ flex: 1 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '0.75rem', color: 'text.secondary' }}>
        <span>Lav intensitet</span>
        <Box sx={{ width: 120, height: 9, borderRadius: '5px', background: `linear-gradient(to right, ${intensityGradient.join(', ')})` }} />
        <span>Høj intensitet</span>
      </Box>
      <Box sx={{ width: '1px', height: 24, bgcolor: 'divider' }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
          Periode
        </Typography>
        <ToggleButtonGroup exclusive size="small" value={period} aria-label="Periode" onChange={(_, value: InterventionLadderPeriod | null) => value && onSelectPeriod(value)}>
          {periods.map(option => (
            <ToggleButton
              key={option.period}
              value={option.period}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                py: 0.25,
                '&.Mui-selected, &.Mui-selected:hover': { bgcolor: selectedColor, color: '#ffffff' },
              }}
            >
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}
